import { BannerType, ContentFulScreens } from "@next-platform/client-common-core";
import appLogger from "@next-platform/client-common-core/logger/appLogger";

const logger = appLogger.withTag("setClosedBannersInSessionStorage");

export type ClosedBannersMap = Record<ContentFulScreens, Record<BannerType, string[]>>;

interface SetClosedBannersParams {
  screen: ContentFulScreens;
  placement: BannerType;
  bannerNames: string[];
}

export const BANNER_STORAGE_KEY = "closedBanners";
export default function setClosedBannersSessionStorage({ screen, placement, bannerNames }: SetClosedBannersParams) {
  try {
    const existingData = sessionStorage.getItem(BANNER_STORAGE_KEY);
    const closedBanners: ClosedBannersMap = existingData ? JSON.parse(existingData) : {};

    if (!closedBanners[screen]) {
      closedBanners[screen] = {} as Record<BannerType, string[]>;
    }

    const existing = closedBanners[screen][placement] || [];

    const updated = Array.from(new Set([...existing, ...bannerNames]));

    closedBanners[screen][placement] = updated;

    sessionStorage.setItem(BANNER_STORAGE_KEY, JSON.stringify(closedBanners));
  } catch (error) {
    logger.error("Failed to update sessionStorage:", error);
  }
}
